<template>
  <div>
    <level-list
        :title="$t('发布者等级设置')"
        ref="list"
        @edit="handleShowDialog"
        @add="handleShowDialog"
        @delete="handleDelete"
        @batch-delete="handleBatchDelete"
        :action="$api.userVipLevel.list" />


    <!-- 积分分类 -->
    <user-integral-category-list class="mtb16" />


    <!--  新增/编辑会员弹窗  -->
    <vip-level-form
        ref="levelForm"
        @save="handleAddOrEditSubmit"
        :data="currentRow"
        :title="isEdit? $t('编辑会员等级') : $t('新增会员等级')"
        :is-edit="isEdit" />
  </div>
</template>

<script>
import LevelList from "@/components/level/LevelList";
import {request, requestByTip} from "@/config/request";
import VipLevelForm from "@/components/level/VipLevelForm";
import UserIntegralCategoryList from "@/components/user-integral-category/UserIntegralCategoryList";
export default {
  name: "UserLevelList",
  components: {UserIntegralCategoryList, VipLevelForm, LevelList},
  data() {
    return {
      isEdit: false,
      currentRow: {}
    }
  },
  methods: {
    // 添加/编辑提交
    async handleAddOrEditSubmit(data) {
      try {
        if(this.isEdit) data.code = this.currentRow.code;
        const action = this.$api.userVipLevel[this.isEdit ? 'update' : 'add'];
        await request(action, data);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.refresh();
      } catch (e) {
        console.log(e);
      }
    },

    // 打开新增/编辑弹窗
    handleShowDialog(row) {
      if(row) {
        this.isEdit = true;
        this.currentRow = {...row};
      } else {
        this.isEdit = false;
      }
      this.$refs.levelForm.showDialog = true
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.userVipLevel.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.refresh(1);
      } catch (e) {
        console.error(e);
      }
    },

    // 批量删除
    async handleBatchDelete(codes) {
      try {
        await requestByTip(this.$api.userVipLevel.batchDelete, codes, {isJson: true});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.refresh(codes.length);
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>

</style>
